
//const FileType = require('file-type');
const config = require('../../config')
var to = require('await-to-js').default
var FormData = require('form-data');
var fs = require("fs")
// Load the service account key JSON file.

// Define the required scopes.
//TODO: will be moved to config
const firebaseConfig = require('../../config/firebase')

const env = process.env.NODE_ENV
let hostName;
if (env === "development"){
	hostName = "http://localhost:8080"
}
else if(env === "production"){
	hostName = firebaseConfig.firebaseFunctionsHostURL
}
console.log("hostname", hostName)
const bucketName = firebaseConfig.storageBucket //default bucket name for now

// Imports the Google Cloud client library.
//let cloud  = require('@google-cloud/storage')
// Instantiates a client. If you don't specify credentials when constructing
// the client, the client library will look for credentials in the
// environment.
// const storage = new Storage({projectId: "curatedcrasheasymobileapp", keyFilename: "C:/Users/Houst/Downloads/curatedcrasheasymobileapp-67a474651a19.json"});
// // Makes an authenticated API request.
// const fs = require('fs');
//   const path = require('path');
  const fileList = [];
  var axios = require('axios')


//FYI: Take a look at the retention policy "eventBasedHold" variable for this function - may be needed for the accident photos; we may want to keep the media until accident process is complete for legal purposes
async function uploadToStorage(params) {
    //bucketName: the name of the sotrage bucket to upload files to
    //fileName: the file name in the local storage to upload to firebase storage
    const cors = require('cors')({origin: true});
	console.log("env", env)

let file = params.file
let destPath = params.filePath
let userToken = params.userToken
let fileUrl = file.url

let  fileErr, fileRes

[fileErr,fileRes] = await to(axios.get(fileUrl,  { responseType: 'arraybuffer' }))
if (fileErr){
    console.error(fileErr)

}
let data = Buffer.from(fileRes.data, 'binary').toString('base64') ///fileRes.data.toString('base64')
console.log("data", data)
//let encode = arrayBufferToBase64(fileRes.data)
//setTimeout(async function(){
    

//setTimeout(arrayBufferToBase64, 250);
//console.log("encode", encode)
let contentType_ = fileRes.headers["content-type"] //unsafe code //fileRes.mime
// //var file_ = fs.createWriteStream(fileName);
var byteArray = new Uint8Array(data);
console.log("byteArray", byteArray)
// const file_ = new File([data], {
// 	type: contentType_
// });
var form = new FormData()
form.append("bucketName", bucketName)
form.append("userToken", userToken)
form.append("contentType", contentType_)
form.append("FileObj", JSON.stringify(file))
form.append("destinationPath", destPath)
form.append("content", data)

console.log("contentType", contentType_)
//console.log("file", file_)

//form.append("file",file_)

return (await( axios.post(hostName + "/uploadFilesv1", form, {headers:{'Content-Type': undefined}})))
//}, 2500);
let response, error;
// return (await to(fetch('http://localhost:8080/uploadFilesv1', {
//     method: 'POST',
//     body: form
//   })))

    

}
async function deleteFileFromStorage(params) {
    //bucketName: the name of the sotrage bucket to upload files to
    //fileName: the file name in the local storage to upload to firebase storage
    const cors = require('cors')({origin: true});
	
    let userToken = params.userToken

let path = params.filePath
//let destPath = "users/0da55291-8ae1-4c41-a98e-224f69a9bd8a/accidents/0b50e031-81b6-4622-a385-24e14ad1fe2b/media/NAKD ss.png"
let fileList = [path];
console.log("filePAths", [path])
var form = new FormData()
form.append("bucketName", bucketName)
form.append("userToken", userToken)
form.append("filePaths",JSON.stringify(fileList))
return (await( axios.post(hostName + "/deleteFilesv1", form, {headers:{'Content-Type': undefined}})))
let response, error;
// return (await to(fetch('http://localhost:8080/uploadFilesv1', {
//     method: 'POST',
//     body: form
//   })))

    

}


async function downloadFromStorage(params) {
    //bucketName: the name of the sotrage bucket to upload files to
    //fileName: the file name in the local storage to upload to firebase storage
    const cors = require('cors')({origin: true});
	console.log("params", params)
    const userToken = params.userToken
    var form = new FormData()

let path = params.filePath
//let destPath = "users/0da55291-8ae1-4c41-a98e-224f69a9bd8a/accidents/0b50e031-81b6-4622-a385-24e14ad1fe2b/media/NAKD ss.png"
let fileList = [path];
console.log("filePAths", [path])
form.append("userToken", userToken)
form.append("bucketName", bucketName)
form.append("filePaths",JSON.stringify(fileList))
return (await( axios.post(hostName + "/downloadFilesv1", form)))
let response, error;
// return (await to(fetch('http://localhost:8080/uploadFilesv1', {
//     method: 'POST',
//     body: form
//   })))

    

}

function arrayBufferToBase64( buffer ) {
	var binary = '';
	var bytes = new Uint8Array( buffer );
	var len = bytes.byteLength;
	for (var i = 0; i < len; i++) {
		binary += String.fromCharCode( bytes[ i ] );
	}
	return window.btoa( binary );
}


module.exports = { uploadToStorage, downloadFromStorage, deleteFileFromStorage}



// WEBPACK FOOTER //
// ./src/services/firebaseStorage.js